import React from "react";
import Text from "./Text";

class Title extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enSlug: "title/en-" + props.slug,
      jpSlug: "title/jp-" + props.slug,
      jpClass: props.jpClass,
      enClass: props.enClass,
      type: props.type,
    };
  }

  render() {
    return (
      <div className="p-title__wrap" data-state={this.state.type}>
        <div className="p-title__wrap--jp">
          <Text
            slug={this.state.jpSlug}
            class={`${this.state.jpClass} p-title__jp c-text--med`}
          />
        </div>
        {this.state.type !== "single" && (
          <div className="p-title__wrap--en">
            <Text
              slug={this.state.enSlug}
              class={`c-text--en p-title__en ${this.state.enClass}`}
            />
          </div>
        )}
      </div>
    );
  }
}

export default Title;
